import { render, staticRenderFns } from "./add-new-year-activity.vue?vue&type=template&id=3110e23e&scoped=true&"
import script from "./add-new-year-activity.vue?vue&type=script&lang=js&"
export * from "./add-new-year-activity.vue?vue&type=script&lang=js&"
import style0 from "./add-new-year-activity.vue?vue&type=style&index=0&id=3110e23e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3110e23e",
  null
  
)

export default component.exports